export default __webpack_public_path__ + "static/up_down_w.e253c939363fc4526e26f33a69ee6ce0.png";